import { motion } from 'framer-motion';

const features = [
  {
    title: 'Fast Pre-Approval',
    description: 'Get approved in as little as 24 hours with our streamlined process. We work efficiently to get you answers quickly.',
    icon: 'ri-file-check-line',
    bg: 'bg-mint',
    image: 'https://public.readdy.ai/ai/img_res/5ba3a80218eb8b85780de2bb464f669b.jpg',
  },
  {
    title: 'Rate Matching',
    description: 'Found a better rate? We will work hard to match or beat competitive offers to ensure you get the best deal.',
    icon: 'ri-shield-check-line',
    bg: 'bg-peach',
    image: 'https://readdy.ai/api/search-image?query=Percentage%20symbol%20with%20protective%20shield%20icon%2C%20financial%20security%20concept%2C%20soft%20peach%20background%2C%20modern%20minimalist%20design%2C%20professional%20illustration%20style%2C%20trust%20and%20protection%20theme%2C%20clean%20composition&width=400&height=400&seq=feature-rate-1&orientation=squarish',
  },
  {
    title: 'Local Expertise',
    description: 'Deep knowledge of local markets and lending requirements. Personalized service from someone who understands your community.',
    icon: 'ri-map-pin-line',
    bg: 'bg-lavender',
    image: 'https://readdy.ai/api/search-image?query=Location%20pin%20with%20house%20icon%2C%20local%20community%20concept%2C%20soft%20lavender%20background%2C%20modern%20flat%20design%2C%20neighborhood%20expertise%20theme%2C%20professional%20illustration%20style%2C%20welcoming%20atmosphere&width=400&height=400&seq=feature-local-1&orientation=squarish',
  },
];

export default function Features() {
  return (
    <section id="loans" className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-4">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-5xl md:text-6xl font-bold text-gray-900"
          >
            Why Choose Me
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-xl text-gray-600 max-w-md"
          >
            Personalized service with competitive rates
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`${feature.bg} rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer`}
            >
              <div className="w-full h-64">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-4xl text-gray-800`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-700 leading-relaxed">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}